require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-students-squash-51-bugs-in-inaugural-partner-bug-bash.json") })
        }
      }, "path---blog-students-squash-51-bugs-in-inaugural-partner-bug-bash");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-students-squash-51-bugs-in-inaugural-partner-bug-bash!./.cache/json/blog-students-squash-51-bugs-in-inaugural-partner-bug-bash.json
// module id = 1087
// module chunks = 231608221292675